import React from "react";
import {

    Content,
    GoodsImg,
    Line,
    MLabel,
    RightControl,
    Title,
    Wrapper,
    WrapperContent,
} from './styles'
import { FaTruck, FaBox } from "react-icons/fa";
import { MdListAlt } from "react-icons/md";

import GoodsImgDefault from "assets/images/goods_default.jpg";

import { Button, Stack } from "@mui/material";

const InvGoodsItem = ({ invGoods, handleNyuko, handleShukko, handleDetials }) => {

    return (
        <Wrapper>
            <WrapperContent>
                <div>
                    <GoodsImg src={invGoods?.ImageUrl1 ? invGoods?.ImageUrl1 : GoodsImgDefault} alt="image" />
                </div>
                <Content>
                    <Title>{invGoods.GoodsName || '-'}</Title>
                    <Line>
                        <MLabel>サイズ：</MLabel>
                        {invGoods.GoodsSize || '―'}
                    </Line>
                    <Line>
                        <MLabel>現在在庫数：</MLabel>
                        {(invGoods.StockQ + (invGoods.StockQMemo || "")) || '-'}
                    </Line>
                </Content>
            </WrapperContent>
            <RightControl>
                <Stack direction="column" spacing={1}>
                    <Button variant="contained" size="small"
                        startIcon={<FaBox />} sx={{ backgroundColor: "#009527", '&:hover': { backgroundColor: "#007a1c" } }}
                        onClick={() => { handleNyuko(invGoods) }}>入庫</Button>
                    <Button variant="contained" size="small" startIcon={<FaTruck />}
                        onClick={(e) => { handleShukko(invGoods) }}>出庫</Button>
                    <Button variant="contained" size="small" color="secondary" startIcon={<MdListAlt />}
                        onClick={(e) => { handleDetials(invGoods) }}
                    >詳細</Button>
                </Stack>
            </RightControl>
        </Wrapper>
    )
}

export default InvGoodsItem;